import { render } from "./BasePagination.vue?vue&type=template&id=9337f9c6&ts=true"
import script from "./BasePagination.vue?vue&type=script&lang=ts"
export * from "./BasePagination.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__